import { defineMessages } from 'react-intl';

export const personCardMessages: {
	share: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	edit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	comment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	share: {
		id: 'search-ui.social-signals.user-card-trigger.shared',
		defaultMessage: '{name} shared',
		description: 'Used in the trigger that shows the social signal for the user',
	},
	edit: {
		id: 'search-ui.social-signals.user-card-trigger.edited',
		defaultMessage: '{name} edited',
		description: 'Used in the trigger that shows the social signal for the user',
	},
	comment: {
		id: 'search-ui.social-signals.user-card-trigger.commented',
		defaultMessage: '{name} commented',
		description: 'Used in the trigger that shows the social signal for the user',
	},
});
